let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ghvP8")).then(() => parcelRequire('fAUFj'));